<template>
  <div class="basic_atlas_catalog">
    <div class="tooptipPart module_edit_btn">
      <my_edit_btn :module="module"></my_edit_btn>
      <template v-if="$store.state.app.view_pattern === 'pc'">
        <my_edit_btn :module="module" tabName="animation"></my_edit_btn>
        <div class="my_edit_btn lineControl styleContent" @click="add_content">
          <span class="el-icon-plus" :title="$t('widgets_basic_atlas_catalog_index_424')"></span>
        </div>
        <my_close_btn :module="module" :column="column" :moduleIndex="module_index"></my_close_btn>
      </template>
    </div>
    <my_title_index :title="infor.title"></my_title_index>
    <div class="list_frame" v-loading="loading" v-if="list.length > 0">
      <!-- 第一种模式 -->
      <template v-if="listArr.module_style == '0'">
        <div class="list_box flex_box new_one_num">
          <template v-for="(item, i) in list">
            <one_img
              :key="i"
              :item="item"
              :height="pc_infor.img_size[pc_infor.img_size.radio_val].height"
              :col="pc_infor.col_num[pc_infor.col_num.radio_val].value"
              :backgroundSize="pc_infor.backgroundSize"
              :paddingLeft="pc_infor.padding[pc_infor.padding.radio_val].paddingLeft"
              :paddingTop="pc_infor.padding[pc_infor.padding.radio_val].paddingTop"
              :all_list="list"
              :module="module"
              @edit_atlas_sure="edit_atlas_sure"
            ></one_img>
          </template>
        </div>
        <my_page_index
          v-if="pc_infor.page.radioValue && list.length > 0"
          :page="pc_infor.page"
          :currentPage.sync="currentPage"
          :total="total"
          @change-page="changePage"
        ></my_page_index>
      </template>

      <!-- 第二种横向无限滚动 -->
      <template v-if="listArr.module_style == '1'">
        <div class="scroll_box new_one_num">
          <div class="imgs_box list_box flex_box headstock">
            <template
              v-for="(val,p_i) in 2"
              v-if="p_i == 1  ? pc_infor.col_num[pc_infor.col_num.radio_val].value < list.length : true"
            >
              <one_img
                v-for="(item,i) in list"
                :key="i + p_i*10000"
                :module="module"
                :item="item"
                :height="pc_infor.img_size[pc_infor.img_size.radio_val].height"
                :col="pc_infor.col_num[pc_infor.col_num.radio_val].value"
                :backgroundSize="pc_infor.backgroundSize"
                :paddingLeft="pc_infor.padding[pc_infor.padding.radio_val].paddingLeft"
                :paddingTop="pc_infor.padding[pc_infor.padding.radio_val].paddingTop"
                :all_list="list"
                @edit_atlas_sure="edit_atlas_sure"
              ></one_img>
            </template>
          </div>
        </div>
      </template>

      <!-- 第三种轮播图模式 -->
      <template v-if="listArr.module_style == '2'">
        <!-- pc模式 -->
        <template v-if="$store.state.app.view_pattern === 'pc'">
          <div class="basic_atlas_catalog_swiper">
            <swiper
              ref="mySwiper"
              class="list_box"
              :options="swiperOption"
              v-if="$store.state.app.basic_atlas_catalog_isRender"
            >
              <swiper-slide v-for="(item,i) in list" :key="i">
                <one_img
                  :item="item"
                  :module="module"
                  :height="pc_infor.img_size[pc_infor.img_size.radio_val].height"
                  :col="pc_infor.col_num[pc_infor.col_num.radio_val].value"
                  :backgroundSize="pc_infor.backgroundSize"
                  :paddingLeft="pc_infor.padding[pc_infor.padding.radio_val].paddingLeft"
                  :paddingTop="pc_infor.padding[pc_infor.padding.radio_val].paddingTop"
                  :all_list="list"
                  type="swiper"
                  @edit_atlas_sure="edit_atlas_sure"
                ></one_img>
              </swiper-slide>
            </swiper>

            <template v-if="$store.state.app.view_pattern === 'pc'">
              <div class="arrow prev" @click="swiper_prev"></div>
              <div class="arrow next" @click="swiper_next"></div>
            </template>
          </div>
        </template>

        <template v-else>
          <div class="list_box flex_box mb_swiper_list">
            <one_img
              v-for="(item,i) in list"
              :key="i"
              :item="item"
              :module="module"
              :height="pc_infor.img_size[pc_infor.img_size.radio_val].height"
              :col="pc_infor.col_num[pc_infor.col_num.radio_val].value"
              :backgroundSize="pc_infor.backgroundSize"
              :paddingLeft="pc_infor.padding[pc_infor.padding.radio_val].paddingLeft"
              :paddingTop="pc_infor.padding[pc_infor.padding.radio_val].paddingTop"
              :all_list="list"
              @edit_atlas_sure="edit_atlas_sure"
            ></one_img>
          </div>
        </template>
      </template>
    </div>
    <template v-if="list.length == 0">
      <div v-if="listArr.type == 'custom'">
        <selection_prompt type="albumList" :ids.sync="listArr.custom" @add_content="add_content"></selection_prompt>
      </div>
      <div v-if="listArr.type == 'systom'">
        <selection_prompt type="albumList" action="class" @select_class="select_class"></selection_prompt>
      </div>
    </template>

    <add_atlas v-if="add_atlas_isShow" @close="add_atlas_close" @submit_sure="submit_sure"></add_atlas>
  </div>
</template>

<script>
import i18n from '../../language/index'

import one_img from "./components/one_img";
import selection_prompt from "@/components/selection_prompt";
import add_atlas from "@/components/basic_addAtlas";
import { box_shadow_style_add } from "@/base/widgets_data_compatible";
export default {
  name: "basic_atlas_catalog",
  data() {
    return {
      list: [],
      loading: false,
      pc_look_isShow: false,
      select_atlas: null,
      go_on_list: [],
      now_x: 0, //滚动动画当前位移
      timer: null,
      add_atlas_isShow: false,
      currentPage: 1,
      total: 0
    };
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  watch: {
    // currentPage() {
    //   this.templet.atlas_catalog_get_atlas(this);
    // },
    listArr: {
      handler: function(val, oldVal) {
        this.reset_rolling();
        this.page_reset();
        this.templet.atlas_catalog_get_atlas(this);
      },
      deep: true
    },
    "pc_infor.page": {
      handler: function(val, oldVal) {
        const reset_before = this.currentPage;
        this.page_reset();
        this.templet.atlas_catalog_get_atlas(this);
        // if(reset_before == 1){
        //   this.templet.atlas_catalog_get_atlas(this);
        // }
        
      },
      deep: true
    }
  },
  methods: {
    changePage(val){
      this.currentPage = val
      this.templet.atlas_catalog_get_atlas(this);
    },
    open_look(item) {
      this.pc_look_isShow = true;
      this.select_atlas = item;
    },
    horizontal_rolling() {
      const num = this.$store.state.app.view_pattern === 'pc' ? this.pc_infor.col_num[this.pc_infor.col_num.radio_val].value : 1
      if  (num < this.list.length ) {
        const headstock = $(`#u${this.module.widgets_id}`).find(".headstock");
        if (this.timer == null) {
          this.timer = setInterval(() => {
            const one_img = $(`#u${this.module.widgets_id}`)
              .find(".list_one")
              .innerWidth();
            if (one_img) {
              const all_width = this.list.length * one_img; //列表总长度
              if (this.now_x <= all_width * -1) {
                this.now_x = 0;
              } else {
                this.now_x = this.now_x - 1;
              }
              headstock.css("transform", `translateX(${this.now_x}px)`);
            }
          }, 1000 / 60);
        }
      }
    },
    //重置滚动
    reset_rolling() {
      this.now_x = 0;
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    swiper_prev() {
      this.$refs.mySwiper.swiper.slidePrev();
    },
    swiper_next() {
      this.$refs.mySwiper.swiper.slideNext();
    },
    add_content() {
      this.add_atlas_isShow = true;
    },
    add_atlas_close() {
      this.add_atlas_isShow = false;
    },

    //新增图册确定返回
    submit_sure(id) {
      this.add_atlas_close();

      //如果选择的是直接添加，则把id加入
      if (this.listArr.type === "custom") {
        this.listArr.custom.push(id);
      }

      this.templet.atlas_catalog_get_atlas(this);
    },
    edit_atlas_sure() {
      this.templet.atlas_catalog_get_atlas(this);
    },

    //选择分类
    select_class() {
      this.listArr.type = "systom";
      this.templet.changeStyle(this.module);
    },
    page_reset() {
      this.list = [];
      this.currentPage = 1;
      this.total = 0;
    }
  },
  computed: {
    listArr() {
      return this.module.data.listArr;
    },
    infor() {
      return this.module.data[
        this.$store.state.app.view_pattern + "_widgets_infor"
      ];
    },
    pc_infor() {
      return this.module.data.pc_widgets_infor;
    },
    swiperOption() {
      const infor = this.module.data.pc_widgets_infor;
      const num = infor.col_num[infor.col_num.radio_val].value;
      return {
        myVm: this,
        loop: false,
        direction: "horizontal",
        slidesPerView: num,
        slidesPerGroup: num,
        observer: true,
        observeParents: true
      };
    }
  },
  components: {
    one_img,
    selection_prompt,
    add_atlas
  },
  created() {
    // 4.6.7 组合阴影
    if (typeof this.pc_infor.boxShadow == "undefined") {
      this.$set(this.pc_infor, "boxShadow", box_shadow_style_add().boxShadow);
    }
    // console.log(8888, this.pc_infor.boxShadow)
  },
  mounted() {
    this.templet.atlas_catalog_get_atlas(this);
  }
};
</script>

<style scoped lang="scss">
.basic_atlas_catalog {
  .tooptipPart {
    .my_edit_btn:hover {
      background-color: #2e343B;
    }
  }
  .flex_box {
    width: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
  .scroll_box {
    overflow: hidden;
    .imgs_box {
      width: 100%;
      flex-wrap: nowrap;
      transform: translateX(0);
      .list_one {
        flex: 0 0 auto;
      }
    }
  }
  .basic_atlas_catalog_swiper {
    padding: 0 60px;
    position: relative;
    /deep/ .list_box {
      .swiper-wrapper {
        .swiper-slide {
          height: auto;
          .list_one {
            height: 100%;
          }
        }
      }
    }
    .arrow {
      cursor: pointer;
      display: block;
      width: 40px;
      height: 40px;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      position: absolute;
      z-index: 99;
      top: 50%;
      -webkit-transform: translateY(-50%);
      -moz-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
      -o-transform: translateY(-50%);
      transform: translateY(-50%);
      background: rgba(0, 0, 0, 0.2);
      -webkit-transition: background 0.15s;
      -o-transition: background 0.15s;
      -moz-transition: background 0.15s;
      transition: background 0.15s;
      outline: 0;
    }

    .arrow:before {
      content: "";
      position: absolute;
      display: block;
      width: 10px;
      height: 18px;
      background: url("/static/image/backimg1.png") -23px -268px;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%) translateY(-50%);
      -moz-transform: translate(-50%) translateY(-50%);
      -ms-transform: translate(-50%) translateY(-50%);
      -o-transform: translate(-50%) translateY(-50%);
      transform: translate(-50%) translateY(-50%);
    }

    .prev {
      left: 10px;
    }

    .next {
      right: 10px;
    }

    .next:before {
      background-position-x: -53px;
      left: 54%;
    }
  }
}

.mb_pattern {
  .basic_atlas_catalog {
    .mb_swiper_list {
      width: 100%;
      display: block;
      white-space: nowrap;
      overflow-x: auto;
      /deep/ .list_one {
        width: 45% !important;
        .basic_atlas_catalog_one_frame {
          // padding: 0;
        }
      }
    }
    .mb_swiper_list::-webkit-scrollbar {
      height: 0px;
    }
    .new_one_num{
      .absolutely{
        width: 100% !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_atlas_catalog/index.vue